import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

import ToastMessage from "../../utils/mui/righttoptoast";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../api/api";

const Estim = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = window.getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const [isNewForm, setIsNewForm] = useState(false);
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
 const[isLoading,setIsLoading]=useState(false)
  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
  });
const [currentformid,setCurrentFormId]=useState('')
  const currentTime = dayjs().format("HH:mm");

  const [tableData, setTableData] = useState([
    {
      date: dayjs().format("YYYY-MM-DD"),
      startTime: currentTime,
      endTime: currentTime,
      treatmentArea: "",
      painScaleLeft: "",
      painScaleRight: "",
      rangeMotionLeft: "",
      rangeMotionRight: "",
      program: "",
      dosage: "",
      improveFunction: "",
    },
  ]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleRowChange = (index, field, value) => {
    setTableData((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addRow = () => {
    const currentTime = dayjs().format("HH:mm");
    setTableData((prev) => [
      ...prev,
      {
        date: "",
        startTime: currentTime,
        endTime: currentTime,
        treatmentArea: "",
        painScaleLeft: "",
        painScaleRight: "",
        rangeMotionLeft: "",
        rangeMotionRight: "",
        program: "",
        dosage: "",
        improveFunction: "",
      },
    ]);
  };
  
const handleNewForm = () => {
  const currentTime = dayjs().format("HH:mm");
  setTableData([{
    date: dayjs().format("YYYY-MM-DD"),
    startTime: currentTime,
    endTime: currentTime,
    treatmentArea: "",
    painScaleLeft: "",
    painScaleRight: "",
    rangeMotionLeft: "",
    rangeMotionRight: "",
    program: "",
    dosage: "",
    improveFunction: "",
  }]);
  setIsNewForm(true); // mark as new
};
  const validateForm = () => {
    const errors = [];
    tableData.forEach((row, index) => {
      const {
        date,
        startTime,
        endTime,
        treatmentArea,
        painScaleLeft,
        painScaleRight,
        rangeMotionLeft,
        rangeMotionRight,
        program,
        dosage,
        improveFunction,
      } = row;

      if (
        !date ||
        !startTime ||
        !endTime ||
        !treatmentArea ||
        !painScaleLeft ||
        !painScaleRight ||
        !rangeMotionLeft ||
        !rangeMotionRight ||
        !program ||
        !dosage ||
        !improveFunction
      ) {
        errors.push(`Please fill all fields in row ${index + 1}.`);
      }
    });

    return errors;
  };

const fetchdate = async () => {
  try {
    const response = await api.post(
      `/v1/${practiseid}/imaging/get-by-date`,
      {
        patientid: data?.patientid,
        examtype: "ESTIM",
        servicedate: dayjs().format("YYYY-MM-DD"),
      }
    );

    if (response?.status === 200 && response?.data?.length > 0) {

      let worksheetData = response.data?.[0]?.data ?? {};

      // 🔥 Handle both string & object structure
      if (typeof worksheetData === "string") {
        try {
          worksheetData = JSON.parse(worksheetData);
        } catch {
          worksheetData = {};
        }
      }

      // 🔥 Handle both key names
      const apiRows =
        worksheetData?.estimrow ||
        worksheetData?.tableData ||
        [];

      if (apiRows.length > 0) {

        const formattedRows = apiRows.map((row) => ({
          date: row?.date_of_service || row?.date || "",
          startTime: row?.start_time || row?.startTime || "",
          endTime: row?.end_time || row?.endTime || "",
          treatmentArea: row?.treatment_area || row?.treatmentArea || "",
          painScaleLeft: row?.pain_scale_before || row?.painScaleLeft || "",
          painScaleRight: row?.pain_scale_after || row?.painScaleRight || "",
          rangeMotionLeft: row?.rom_before || row?.rangeMotionLeft || "",
          rangeMotionRight: row?.rom_after || row?.rangeMotionRight || "",
          program: row?.program_no || row?.program || "",
          dosage: row?.dosage || "",
          improveFunction: row?.improve_function || row?.improveFunction || "",
        
        }));
setCurrentFormId(response.data?.[0]?.id)
        setTableData(formattedRows);
        return;
      }
    }

    // ❌ No API rows → create today's default row
    const now = dayjs().format("YYYY-MM-DD");
    const time = dayjs().format("HH:mm");

    setTableData([
      {
        date: now,
        startTime: time,
        endTime: time,
        treatmentArea: "",
        painScaleLeft: "",
        painScaleRight: "",
        rangeMotionLeft: "",
        rangeMotionRight: "",
        program: "",
        dosage: "",
        improveFunction: "",
      },
    ]);

  } catch (error) {
    console.error("Fetch ESTIM error:", error);
  }
};
useEffect(()=>{
fetchdate()
},[data])
const handleSave = async () => {
  const errors = validateForm();
  if (errors.length > 0) {
    setToastMessage(errors[0]);
    setToastSeverity("error");
    setOpenToast(true);
    return;
  }

  const payload = {
    patientDetails: {
      patientid: data.patientid,
      appointmentid: data.appointmentid,
      firstname: data.firstname,
      lastname: data.lastname,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      dob: formattedDOB,
      age,
      gender: data.gender === "M" ? "Male" : "Female",
    },
    formDetails: formData,
    tableData: tableData,
  };

  try {
    setIsLoading(true);
    const user = await api.get('/auth/me');
    const [year, month, day] = formData.examDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;

    const response = await api.post(
      `/v1/${practiseid}/patient/${data.patientid}/imaging/estim/insert-db`,
      {
        Worksheet_Type: "ESTIM",
        createdby: user?.username || '',
        appurl: window.location.origin,
        Exam_Date: formattedDate,
        data: payload,
      isNew: isNewForm ? 'Y' : 'N',
      }
    );

    if (response.status === 200) {
      setToastMessage("Saved Successfully");
      setToastSeverity("success");
      setOpenToast(true);
    } else {
      setToastMessage(response.message);
      setToastSeverity("info");
      setOpenToast(true);
    }
  } catch (error) {
    console.log(error);
    setToastMessage("Something went wrong");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
  }
};

const handleSendToEMR = async () => {
  const errors = validateForm();
  if (errors.length > 0) {
    setToastMessage(errors[0]);
    setToastSeverity("error");
    setOpenToast(true);
    return;
  }

  const payload = {
    patientDetails: {
      patientid: data.patientid,
      appointmentid: data.appointmentid,
      firstname: data.firstname,
      lastname: data.lastname,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      dob: formattedDOB,
      age,
      gender: data.gender === "M" ? "Male" : "Female",
    },
    formDetails: formData,
    tableData: tableData,
  };

  try {
    setIsLoading(true);
    const user = await api.get('/auth/me');
    const [year, month, day] = formData.examDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;

    const response =  await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,
        {
          filename: currentformid,
          worksheet_type: "ESTIM",
          appurl: window.location.origin,
          exam_date: formattedDate,
        }
      );

    if (response.status === 200) {
    

      setToastMessage("Form Sent to EMR");
      setToastSeverity("success");
      setOpenToast(true);
      resetForm();
      setTimeout(() => setIsmodal(false), 1000);
    } else {
      setToastMessage(response.message);
      setToastSeverity("info");
      setOpenToast(true);
    }
  } catch (error) {
    console.log(error);
    setToastMessage("Something went wrong");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
  }
};
//   const handleSave = async() => {
//     const errors = validateForm();
//     if (errors.length > 0) {
//       setToastMessage(errors[0]);
//       setToastSeverity("error");
//       setOpenToast(true);
//     } else {
//   setToastMessage("Saved successfully!");
//   setToastSeverity("success");
//   setOpenToast(true);



//   const payload = {
//     patientDetails: {
//       patientid: data.patientid,
//       appointmentid: data.appointmentid,
//       firstname: data.firstname,
//       lastname: data.lastname,
//       pat_name: `${data?.firstname} ${data?.lastname}`,
//         pat_dob: data?.dob,
//       dob: formattedDOB,
//       age,
//       gender: data.gender === "M" ? "Male" : "Female",
//     },
//     formDetails: formData,
//     tableData: tableData,
//   };
// try {
//     setIsLoading(true)

//      const user=await api.get('/auth/me')
//           const [year, month, day] = formData.examDate.split("-");
//           const formattedDate = `${month}/${day}/${year}`;
      
//       const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/estim/insert-db`, {
//         "Worksheet_Type": "ESTIM",
//         "createdby": user?.username || '',
//         "appurl": window.location.origin,
     
//         "Exam_Date": formattedDate,
//         "data":payload,
//         isNew:'N',  //N
//       });
      
//       if(response.status==200){
//         const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
//         "filename": response?.data?.filename,      
//         "worksheet_type":"ESTIM",
//          "appurl": window.location.origin,
//         "exam_date": formattedDate
//         })
//         setToastMessage("Form Submitted Successfully");
//           setToastSeverity("success");
//           setOpenToast(true);
//           resetForm()
//        setTimeout(() => {
    
//         setIsmodal(false);
//       }, 1000);
      
//       }else{
//         setToastMessage(response.message);
//           setToastSeverity("info");
//           setOpenToast(true);
//       }
// } catch (error) {
//   console.log(error)
// }finally{
// setIsLoading(false)
// }
// }

//   };
const resetForm = () => {
  setCurrentFormId('')
  setIsNewForm('N')
setTableData([
    {
      date: dayjs().format("YYYY-MM-DD"),
      startTime: currentTime,
      endTime: currentTime,
      treatmentArea: "",
      painScaleLeft: "",
      painScaleRight: "",
      rangeMotionLeft: "",
      rangeMotionRight: "",
      program: "",
      dosage: "",
      improveFunction: "",
    },
  ])

}
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">ESTIM</h2>
          <button
            onClick={() => setIsmodal(false)}
            className="text-xl font-bold text-gray-500 hover:text-black"
          >
            ×
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
             #{data?.patientid}
            </div>
            <div className="text-base font-semibold">
              {data?.firstname + " " + data?.lastname}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span>{" "}
              {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} |{" "}
              <span className="font-semibold">Gender:</span>{" "}
              {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        <div className="overflow-visible w-full mb-6 relative z-20">
          <div className="flex justify-end mb-2 gap-2">
 <button
  onClick={handleSendToEMR}
  disabled={!currentformid}
  className={`px-3 py-1 rounded text-white
    ${!currentformid
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-blue-600 hover:bg-blue-700"}
  `}
>
  Send to EMR
</button>
  <button
    onClick={() => {
      const currentTime = dayjs().format("HH:mm");
      setTableData([
        {
          date: dayjs().format("YYYY-MM-DD"),
          startTime: currentTime,
          endTime: currentTime,
          treatmentArea: "",
          painScaleLeft: "",
          painScaleRight: "",
          rangeMotionLeft: "",
          rangeMotionRight: "",
          program: "",
          dosage: "",
          improveFunction: "",
        },
      ]);
    }}
    className="bg-gray-500 text-white px-3 py-1 rounded hover:bg-gray-600"
  >
    New Form
  </button>
</div>

          <table className="w-full border-collapse table-auto text-sm relative z-20">
            <thead>
              <tr className="bg-gray-50 text-xs">
                <th className="border p-2">DATE OF SERVICE</th>
                <th className="border p-2">START TIME</th>
                <th className="border p-2">END TIME</th>
                <th className="border p-2">TREATMENT AREA</th>
                <th className="border p-2">PAIN SCALE (1-10)</th>
                <th className="border p-2">RANGE OF MOTION (1-10)</th>
                <th className="border p-2">PROGRAM #</th>
                <th className="border p-2">DOSAGE</th>
                <th className="border p-2">IMPROVE FUNCTION</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="border p-2">
                    <input
                      type="date"
                      value={row.date}
                      onChange={(e) =>
                        handleRowChange(i, "date", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="time"
                      value={row.startTime}
                      onChange={(e) =>
                        handleRowChange(i, "startTime", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="time"
                      value={row.endTime}
                      onChange={(e) =>
                        handleRowChange(i, "endTime", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={row.treatmentArea}
                      onChange={(e) =>
                        handleRowChange(i, "treatmentArea", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
                  <td className="border p-2">
                    <div className="flex flex-col w-full gap-1">
                      <input
                        type="number"
                        placeholder="Before"
                        value={row.painScaleLeft}
                        onChange={(e) =>
                          handleRowChange(i, "painScaleLeft", e.target.value)
                        }
                        className="w-full p-1 border rounded"
                      />
                      <input
                        type="number"
                        placeholder="After"
                        value={row.painScaleRight}
                        onChange={(e) =>
                          handleRowChange(i, "painScaleRight", e.target.value)
                        }
                        className="w-full p-1 border rounded"
                      />
                    </div>
                  </td>
                  <td className="border p-2">
                    <div className="flex flex-col gap-1">
                      <input
                        type="number"
                        placeholder="Before"
                        value={row.rangeMotionLeft}
                        onChange={(e) =>
                          handleRowChange(i, "rangeMotionLeft", e.target.value)
                        }
                        className="w-full p-1 border rounded"
                      />
                      <input
                        type="number"
                        placeholder="After"
                        value={row.rangeMotionRight}
                        onChange={(e) =>
                          handleRowChange(i, "rangeMotionRight", e.target.value)
                        }
                        className="w-full p-1 border rounded"
                      />
                    </div>
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={row.program}
                      onChange={(e) =>
                        handleRowChange(i, "program", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
              <td className="border p-2">
  <input
    type="text"
    value={row.dosage}
    onChange={(e) =>
      handleRowChange(i, "dosage", e.target.value)
    }
    className="w-full p-1 border rounded"
  />
</td>

                  <td className="border p-2">
                    <input
                      type="text"
                      value={row.improveFunction}
                      onChange={(e) =>
                        handleRowChange(i, "improveFunction", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-2">
            <button
              onClick={addRow}
              className="bg-blue-400 px-4 py-1 rounded-md text-white"
            >
              Add +
            </button>
          </div>
        </div>

        <div className="flex justify-end mt-6">
        <button
  // disabled={true}
  onClick={handleSave}
  className={`px-4 py-2 rounded text-white 
    ${false? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"}`}
>
  Save
</button>
        </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={() => setOpenToast(false)}
        />
      </div>
    </div>
  );
};

export default Estim;
